import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'PolicyView',
    component: () => import(/* webpackChunkName: "daily_health_policy" */ '@/views/PolicyView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/faq',
    name: 'FAQView',
    component: () => import(/* webpackChunkName: "daily_health_policy" */ '@/views/FAQView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/contact',
    name: 'ContactView',
    component: () => import(/* webpackChunkName: "daily_health_policy" */ '@/views/ContactView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/menu',
    name: 'MenuView',
    component: () => import(/* webpackChunkName: "daily_health_policy" */ '@/views/MenuView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/activity',
    name: 'ActivityView',
    component: () => import(/* webpackChunkName: "daily_health_policy" */ '@/views/ActivityView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },

  {
    path: '/auth',
    name: 'AuthPage',
    component: () => import(/* webpackChunkName: "daily_health" */ '@/views/AuthPage.vue'),
    meta: {
      authenticated: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "daily_health" */ '@/views/NotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
